export const minAssetPrice = 100;
export const maxAssetPrice = 10000000;

export const minAssetDescription = 10;
export const maxAssetDescription = 1000;

export const minAssetTitle = 2;
export const maxAssetTitle = 100;
